module.exports = __webpack_public_path__ + "static/controlpannel-ed7a6f8a9665fb058271a046e1cc2efa.png";